<template>
  <div>
    <div :class="{'upload_container': true, 'no_url': !imageUrl}">
      <el-upload
        v-if="!imageUrl"
        class="upload-cmp"
        name="Filedata"
        :accept="'image/png, image/jpeg'"
        :action="AUTHFILE"
        :disabled="disabled"
        :show-file-list="false"
        :headers="upHeaders"
        :data="UPFILEFORMDATAUSER"
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :on-error="uploadError">
        <span class="upload-btn">点击上传</span>
        <p class="other_msg">
          <slot></slot>
        </p>
      </el-upload>
      <img v-else class="img_item" :src="imageUrl" alt="" @click="showImage">
      <span v-show="imageUrl && !disabled" class="close_btn" @click="deleteImg">x</span>
    </div>
    <el-dialog class="img_preview" :visible.sync="preview" :show-close="false">
      <img class="big_img" :src="imageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script type="text/javascript">

export default {
  name: 'UploadImage',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      preview: false,
      load: null,
      upHeaders: {
        token: localStorage.getItem('user_ticket') || undefined
      }
    }
  },
  computed: {
    imageUrl: {
      get() { return this.imgSrc },
      set(nv) { this.$emit('update:imgSrc', nv) }
    }
  },
  methods: {
    beforeUpload(file) {
      if (file && ['image/jpeg', 'image/png'].indexOf(file.type) < 0) {
        this.$message.warning('仅支持上传JPEG/PNG格式的图片')
        return false
      } else if (file && (file.size / (1024 * 1024)) > 5) {
        this.$message.warning('仅支持上传5M以内的图片')
        return false
      }
      this.load = this.$loading()
    },
    uploadSuccess(res) {
      if (this.load) this.load.close()
      if (res && res.code === 0) {
        this.imageUrl = res.reourceAddress
      } else {
        this.$message.error(res.message || res.msg)
      }
    },
    uploadError(e) {
      if (this.load) this.load.close()
    },
    deleteImg() {
      this.imageUrl = ''
    },
    showImage() {
      this.preview = true
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-cmp {
  width: 100%;
  height: 100%;
  ::v-deep .el-upload {
    width: 100%;
    height: 100%;
  }
}
.upload_container {
  position: relative;
  display: inline-block;
  width: 200px;
  height: 120px;
  background-color: #282729;
  border: 1px solid #E9E9E9;
  border-radius: 4px;
  text-align: center;
  &.no_url {
    background-color: #F5F5F5;
  }
}
.upload-btn {
  display: block;
  width: 100px;
  height: 24px;
  margin: 35px auto 10px;
  color: $main-color;
  font-size: 12px;
  line-height: 24px;
  border: 1px solid $main-color;
  border-radius: 4px;
}
.other_msg {
  color: #282729;
  font-size: 12px;
  line-height: 17px;
  margin-top: 10px;
  ::v-deep .sub {
    color: #999;
  }
}
.img_item {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}

.close_btn {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  display: block;
  width: 18px;
  height: 18px;
  color: #fff;
  text-align: center;
  line-height: 18px;
  background-color: $main-color;
  border-radius: 4px;
}
.img_preview {
  ::v-deep .el-dialog__body {
    padding: 0 20px 30px;
  }
  .big_img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }
}
</style>
